<script setup lang="ts">
import { inject, Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useViewComposable } from '@/views/composable';
import Button from 'primevue/button';

const dialogRef = inject('dialogRef') as Ref;
const isSuccess = dialogRef?.value?.data?.isSuccess;
const authNumber = dialogRef?.value?.data?.authNumber;
const amount = dialogRef?.value?.data?.amount;
const onClose = dialogRef?.value?.options?.emits?.onClose;

const { t } = useI18n({ useScope: 'global' });
const { renderAmount } = useViewComposable();

const renderTitle = (isSuccess: boolean) => {
  return isSuccess ? t('payment.payment_approved') : t('payment.declined');
};

const renderContent = (isSuccess: boolean) => {
  return isSuccess ? t('payment.payment_accepted') : t('payment.payment_declined');
};
</script>

<template>
  <div class="payment-status-modal flex flex-column">
    <div class="title mb-2 text-2xl uppercase text-center pb-2 px-2 font-bold">{{ renderTitle(isSuccess) }}</div>
    <div class="text-center pb-2 px-2">
      <i v-if="isSuccess" class="pi pi-check-circle text-green-700 font-bold"></i>
      <i v-else class="primary-text pi pi-times-circle text-primary font-bold"></i>
      <span class="content"> {{ $t('payment.your_payment') }} {{ renderAmount(amount) }} {{ renderContent(isSuccess) }} </span>
    </div>
    <div v-if="isSuccess" class="text-center pb-2 px-2">{{ $t('payment.authorization_number') }} {{ authNumber }}</div>
    <div class="text-center mt-2">
      <Button id="close-btn" :label="$t('common.buttons.ok')" @click="onClose()"></Button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.payment-status-modal {
  width: min(400px, 45vw);
  align-items: center !important;
}
</style>
